export const ActionTypes = {
  CHANGE_MEMBER_SUPPORT_CONTENT: 'CHANGE_MEMBER_SUPPORT_CONTENT',
  CHANGE_MEMBER_SUPPORT_NAME: 'CHANGE_MEMBER_SUPPORT_NAME',
  SEND_MEMBER_SUPPORT_REQUEST: 'SEND_MEMBER_SUPPORT_REQUEST',
  SUCCESS_SEND_MEMBER_SUPPORT_REQUEST: 'SUCCESS_SEND_MEMBER_SUPPORT_REQUEST',
  ERROR_SEND_MEMBER_SUPPORT_REQUEST: 'ERROR_SEND_MEMBER_SUPPORT_REQUEST',
};
